import React, { useState, useEffect } from "react";
import RateForm from "./form";
import Datatables from "../../../utils/table/datatable";
import { CorierRateColumns } from "helpers/DatatableColumns";
import { get } from "helpers/api_helper";
import { COURIERRATE } from "helpers/url_helper";


const Rates = () => {
    const [ isForm , setIsForm ] = useState(false);
    const [ courierRatesList , setCourierRatesList ] = useState([]);
    const [ pagination, setPagination ] = useState({
        page: 1,
        limit: 10,
        search: '',
    })

    
    const toggleForm = () => {
        const t = !isForm;
        setIsForm(!isForm);
        if(t == false){
            alert('asd');
            getCourierRatesList();
        }
    }
    
    const getCourierRatesList = async () => {
        const { success, data } = await get(`${COURIERRATE}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if(success){
            setCourierRatesList(data);
        }
    }

    useEffect(() => {
        getCourierRatesList();
    }, [pagination]);

    return (
        isForm ? <RateForm cb={toggleForm} /> :
            <Datatables 
                isSearch={true}
                columns = {CorierRateColumns}
                showTableOnly={true}
                rowsLength={courierRatesList?.totalRows || 0}
                rows = {courierRatesList?.data || []}
                keyField={'id'}
                handleAddButton={toggleForm}            
                title = "All Zones"
                loading = {false}
                isAdd = {true}
                isTableHead = {true}
                ssr={(page) => setPagination(page)}
            />
    );
};

export default Rates;